import { lightTheme } from './themes/light/index';
import { darkTheme } from './themes/dark/index';

import { ThemeIdEnum } from './enums';

const { LIGHT, DARK } = ThemeIdEnum;

export const themeRegistry = {
	[LIGHT]: lightTheme,
	[DARK]: darkTheme,
};
